import React from 'react';
import styles from './StepGuide.module.css';

interface StepGuideProps {
  visible: boolean;
}

const StepGuide: React.FC<StepGuideProps> = ({ visible }) => {
  if (!visible) return null;
  
  return (
    <div className={styles.guideContainer}>
      <h2 className={styles.guideTitle}>How to Use Tracking Simulator</h2>
      
      <div className={styles.stepsContainer}>
        <div className={styles.step}>
          <div className={styles.stepIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepTitle}>Step 1</h3>
            <p className={styles.stepDescription}>Set API Key and Backend</p>
          </div>
        </div>
        
        <div className={styles.step}>
          <div className={styles.stepIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
              <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
              <line x1="12" y1="11" x2="12" y2="17"></line>
              <line x1="9" y1="14" x2="15" y2="14"></line>
            </svg>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepTitle}>Step 2</h3>
            <p className={styles.stepDescription}>Enter Vehicle Ride ID</p>
          </div>
        </div>
        
        <div className={styles.step}>
          <div className={styles.stepIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepTitle}>Step 3</h3>
            <p className={styles.stepDescription}>Select Location Sources</p>
          </div>
        </div>
        
        <div className={styles.step}>
          <div className={styles.stepIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          </div>
          <div className={styles.stepContent}>
            <h3 className={styles.stepTitle}>Step 4</h3>
            <p className={styles.stepDescription}>Hit Play</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepGuide;
